module.exports = __webpack_public_path__ + "static/kentpark-web-db13c2f5dccc83c9fc64272caafd9a2c.jpg";